module.exports = __webpack_public_path__ + "static/media/y.8fe1ac7a.svg";